import entities from '../../../../config/Entities'
import { HALApiService } from '../hal-api.service'
import { createItemsData } from './../../helpers/request-helpers'
import { CachedService } from './base-service'

export const supplyService = new CachedService(entities.Orderadmin_Storage_Entity_Supply, '/storage/supplies', HALApiService, createItemsData)
